import type { CommandHandler } from '../types';

export const createTasksAndWorkLogsCommandHandler: CommandHandler = (command, context) => {
  const projectId = Number(context.parentId ?? context.entityId);
  if (!Number.isInteger(projectId) || projectId <= 0) {
    return {
      success: false,
      error: 'Open a saved project first.',
    };
  }

  if (!context.openCreateTasksAndWorkLogsDialog) {
    return {
      success: false,
      error: 'Create tasks and work logs dialog is not available.',
    };
  }

  context.openCreateTasksAndWorkLogsDialog(command, projectId);
  return { success: true };
};
